<template>
  <div class="page_tips" v-show="show">{{info}}</div>
</template>

<script>
  export default {
    name: 'error-tip',
    props: ['show', 'info']
  }
</script>



/** WEBPACK FOOTER **
 ** error-tip.vue?6c2c3182
 **/